if (typeof window === "undefined") {
  module.exports = {};
} else {
  module.exports = require("../../utils/vendor/scrollmagic/plugins/animation.gsap.js");
}
